import styled, { css } from "styled-components";
import { theme } from "@sqymagma/theme";

const ActionButton = styled.div`
  display: flex;
  cursor: pointer;
  gap: ${(p) => p.theme.spacing.xxxs};
  align-items: center;

  &:hover {
    span {
      color: ${(p) => p.theme.colors.interactive01Hover};
    }
    svg {
      path,
      circle {
        fill: ${(p) => p.theme.colors.interactive01Hover};
      }
    }
  }
`;

const Reaction = styled.div<{ $isUserReaction: boolean; $isUserMood: boolean }>`
  ${theme("textStyle.body")};
  display: flex;
  align-items: center;
  gap: ${(p) => p.theme.spacing.xxxs};
  padding: ${(p) => p.theme.spacing.xxxs};
  border-radius: ${(p) => p.theme.radii.s};
  border: 1px solid
    ${(p) =>
      p.$isUserReaction
        ? p.theme.colors.interactive05Active
        : p.$isUserMood
        ? p.theme.colors.ui06
        : p.theme.colors.line01};
  background-color: ${(p) =>
    p.$isUserReaction
      ? p.theme.colors.interactive05Active
      : p.$isUserMood
      ? p.theme.colors.brand06
      : p.theme.colors.tertiaryBackground};
  cursor: pointer;

  &:hover {
    ${(p) =>
      !p.$isUserReaction &&
      css`
        background-color: ${(p) => p.theme.colors.interactive05Hover};
      `}
    & > span:first-child {
      transform: scale(1.2);
    }
  }
`;

const ReactionTooltip = styled.div<{ $columns: number }>`
  display: grid;
  gap: ${(p) => p.theme.spacing.xxxs};
  grid-template-columns: repeat(${(p) => p.$columns}, auto);
`;

const MessageWrapper = styled.div`
  position: relative;
`;

const ReadMore = styled.div<{ $isUserMood?: boolean }>`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  ${theme("textStyle.button")};
  cursor: pointer;

  &:hover {
    background: ${(p) =>
      p.$isUserMood ? p.theme.colors.overlay05 : p.theme.colors.overlay04};
  }

  &:hover:after {
    opacity: 1;
    transition: opacity 0.3s ease-in-out;
  }

  &:after {
    opacity: 0;
    content: "Ver más";
    color: ${(p) => p.theme.colors.text02};
    background-color: ${(p) => p.theme.colors.secondaryBackground};
    padding: ${(p) => p.theme.spacing.xxs} ${(p) => p.theme.spacing.xs};
    border-radius: ${(p) => p.theme.radii.l};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }

  &:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 70px;
    background: ${(p) =>
      p.$isUserMood
        ? p.theme.gradient.gradient02
        : p.theme.gradient.gradient01};
  }
`;

export { ActionButton, Reaction, ReactionTooltip, MessageWrapper, ReadMore };
